import { motion } from "framer-motion";
import { NOXN } from "@/constants/testIds";

const KINETIC = "https://static.prod-images.emergentagent.com/jobs/7a9b6db3-da51-486d-b381-a72900b8fc1d/images/81bba1a5347dacd6a59923d5712c95bde5d01ad7b7146a76d238b3bc90a17d22.png";

const steps = [
    {
        n: "01",
        title: "Pick screens",
        body: "Browse the live map, compare transparent daily rates, and pick the screens and cities that fit your campaign.",
    },
    {
        n: "02",
        title: "Lock your dates",
        body: "Choose your launch date and budget. Available screens are held exclusively for you for 20 minutes while you pay.",
    },
    {
        n: "03",
        title: "Upload artwork",
        body: "Supply your ready-to-run advertisement. We check it against every screen's specs and coordinate operator approvals.",
    },
    {
        n: "04",
        title: "Go live",
        body: "Your campaign lights up on the agreed date. A play log with estimated impressions lands in your inbox after the run.",
    },
];

const fadeIn = (delay = 0) => ({
    initial: { opacity: 0, y: 24 },
    whileInView: { opacity: 1, y: 0 },
    viewport: { once: true, margin: "-80px" },
    transition: { duration: 0.8, delay, ease: [0.16, 1, 0.3, 1] },
});

export const Process = () => {
    return (
        <section
            id="process"
            data-testid={NOXN.processSection}
            className="relative py-14 lg:py-20 overflow-hidden"
        >
            <div className="absolute inset-0 -z-10">
                <img src={KINETIC} alt="" className="w-full h-full object-cover opacity-15" />
                <div className="absolute inset-0 bg-gradient-to-b from-[#152A55] via-[#152A55]/85 to-[#152A55]" />
            </div>

            <div className="mx-auto max-w-7xl px-6 lg:px-10">
                <motion.div {...fadeIn(0)} className="max-w-3xl mb-12">
                    <div className="font-mono-tech text-[11px] uppercase tracking-[0.35em] text-[#FF5A00] mb-6 flex items-center gap-3">
                        <span className="inline-block w-6 h-px bg-[#FF5A00]" />
                        05 / How it works
                    </div>
                    <h2 className="font-display font-black tracking-tighter text-white text-4xl sm:text-5xl lg:text-6xl leading-[0.95]">
                        From idea to lit skyline<br />
                        <span className="text-slate-500">in four straightforward steps.</span>
                    </h2>
                    <p className="mt-6 text-slate-400 max-w-2xl leading-relaxed">
                        No lock-ins. No phone tag. You&apos;re paying for screens and days,
                        not for the platform in between.
                    </p>
                </motion.div>

                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-px bg-white/5 border border-white/5">
                    {steps.map((s, i) => (
                        <motion.div
                            key={s.n}
                            {...fadeIn(0.05 * i)}
                            data-testid={NOXN.processStep(s.n)}
                            className="bg-[#0F1E3B] p-10 lg:p-12 hover:bg-[#1B2E55] transition-colors duration-500 group card-lift"
                        >
                            <div className="font-display font-black text-7xl lg:text-8xl text-white/5 group-hover:text-[#FF5A00]/30 transition-colors duration-500 leading-none">
                                {s.n}
                            </div>
                            <div className="mt-8">
                                <h3 className="font-display font-black tracking-tight text-2xl text-white">
                                    {s.title}
                                </h3>
                                <p className="mt-3 text-sm text-slate-400 leading-relaxed">
                                    {s.body}
                                </p>
                            </div>
                            <div className="mt-8 h-px w-12 bg-[#FF5A00] group-hover:w-full transition-all duration-700" />
                        </motion.div>
                    ))}
                </div>
            </div>
        </section>
    );
};
